<div class="min-h-screen bg-gradient-to-br from-slate-50 to-purple-50">
  <div class="container mx-auto px-4 py-8">
    
    <!-- Header -->
    <div class="mb-8">
      <div class="flex items-center mb-4">
        <div class="bg-gradient-to-r from-purple-500 to-indigo-600 p-3 rounded-xl shadow-lg mr-4">
          <svg class="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"></path>
          </svg>
        </div>
        <div>
          <h1 class="text-4xl font-bold bg-gradient-to-r from-gray-800 to-gray-600 bg-clip-text text-transparent">
            Reporte de Ejecución Presupuestal
          </h1>
          <p class="text-gray-600 mt-1">Análisis gerencial completo de proyectos para toma de decisiones</p>
        </div>
      </div>
    </div>

    <!-- Main Content Card -->
    <div class="bg-white rounded-2xl shadow-xl border border-gray-100 overflow-hidden">
      
      <!-- Card Header -->
      <div class="bg-gradient-to-r from-purple-50 to-indigo-50 border-b border-gray-100 p-6">
        <h2 class="text-xl font-semibold text-gray-800 flex items-center">
          <svg class="w-5 h-5 mr-2 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"></path>
          </svg>
          Configuración del Reporte Gerencial
        </h2>
        <p class="text-gray-600 text-sm mt-1">Seleccione el proyecto para generar el análisis completo de ejecución presupuestal</p>
      </div>

      <!-- Form Content -->
      <div class="p-6">
        <div class="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
          
          <!-- Selector de Proyecto -->
          <div class="space-y-2">
            <label for="project" class="block text-sm font-semibold text-gray-700 flex items-center">
              <svg class="w-4 h-4 mr-1 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-4m-5 0H9m0 0H7m2 0v-5a2 2 0 012-2h2a2 2 0 012 2v5m-6 0V9a2 2 0 012-2h2a2 2 0 012 2v8"></path>
              </svg>
              Proyecto *
            </label>
            <p-dropdown
              id="project"
              [(ngModel)]="selectedProjectId"
              [options]="projectsDropdown"
              [filter]="true"
              filterBy="label"
              [showClear]="true"
              placeholder="Seleccionar proyecto"
              optionLabel="label"
              optionValue="value"
              class="w-full custom-dropdown">
            </p-dropdown>
            <p class="text-xs text-gray-500 mt-1">⚡ Reporte gerencial más importante del sistema</p>
          </div>

          <!-- Información del Proyecto Seleccionado -->
          <div class="space-y-2">
            <div class="bg-gradient-to-r from-purple-50 to-indigo-50 p-4 rounded-lg border border-purple-200">
              <div class="flex items-start">
                <svg class="w-5 h-5 text-purple-600 mt-0.5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                </svg>
                <div>
                  <h4 class="text-sm font-semibold text-purple-800">📊 Reporte de Ejecución Presupuestal</h4>
                  <p class="text-xs text-purple-600 mt-1">
                    • Formato profesional basado en estructura de comprobantes<br>
                    • Resumen ejecutivo con métricas financieras reales<br>
                    • Detalle completo por categorías presupuestales<br>
                    • Análisis de ingresos vs gastos proyectados vs ejecutados<br>
                    • Movimientos detallados de ingresos del proyecto
                  </p>
                </div>
              </div>
            </div>
          </div>

        </div>

        <!-- Current Selection Display -->
        <div class="bg-gray-50 rounded-lg p-4 mb-6">
          <h3 class="text-lg font-semibold text-gray-800 mb-2">Selección Actual:</h3>
          <div class="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
            <div>
              <span class="font-medium text-gray-600">Proyecto:</span>
              <span class="ml-2 text-gray-800">{{ selectedProjectName }}</span>
            </div>
            <div>
              <span class="font-medium text-gray-600">Tipo:</span>
              <span class="ml-2 text-purple-600 font-medium">📊 Ejecución Presupuestal Completa</span>
            </div>
          </div>
        </div>

        <!-- Action Buttons -->
        <div class="flex flex-col sm:flex-row justify-end gap-4">
          <button
            (click)="downloadExcelReport()"
            [disabled]="!isFormValid || loading"
            class="px-8 py-3 bg-gradient-to-r from-purple-600 to-indigo-600 text-white font-semibold rounded-xl shadow-lg hover:from-purple-700 hover:to-indigo-700 transform hover:scale-105 transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none flex items-center justify-center min-w-[200px]">
            
            <div *ngIf="loading" class="flex items-center">
              <div class="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-3"></div>
              <span>Generando Reporte...</span>
            </div>
            
            <div *ngIf="!loading" class="flex items-center">
              <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 10v6m0 0l-3-3m3 3l3-3M3 17V7a2 2 0 012-2h6l2 2h6a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z"></path>
              </svg>
              <span>📊 Descargar Reporte Ejecutivo</span>
            </div>
          </button>
        </div>

      </div>
    </div>

    <!-- My Reports Section -->
    <app-recent-report-jobs></app-recent-report-jobs>

    <!-- Help Section -->
    <div class="mt-8 bg-white rounded-xl shadow-sm border border-gray-100 p-6">
      <div class="flex items-start">
        <div class="flex-shrink-0">
          <svg class="w-6 h-6 text-purple-500 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
          </svg>
        </div>
        <div class="ml-4">
          <h4 class="text-lg font-medium text-gray-800">📊 Reporte de Ejecución Presupuestal por Proyecto</h4>
          <div class="mt-2 text-sm text-gray-600 space-y-1">
            <p><strong>🎯 Reporte Gerencial Completo:</strong> Análisis financiero integral con datos reales del sistema</p>
            <p><strong>📋 Estructura Profesional:</strong> Basado en el formato exitoso de reportes de comprobantes</p>
            <ul class="ml-4 space-y-1 mt-2">
              <li>• <strong>Resumen Ejecutivo:</strong> Información del proyecto, participantes, estado y métricas clave</li>
              <li>• <strong>Métricas Financieras:</strong> Ingresos y gastos proyectados vs ejecutados con porcentajes</li>
              <li>• <strong>Análisis de Utilidad:</strong> Utilidad proyectada vs real con cálculos precisos</li>
              <li>• <strong>Resumen de Movimientos:</strong> Totales de comprobantes, órdenes, excesos y devoluciones</li>
              <li>• <strong>Detalle Presupuestal:</strong> Categorías y subcategorías con ejecución y variaciones</li>
              <li>• <strong>Detalle de Ingresos:</strong> Listado completo de movimientos de ingresos del proyecto</li>
            </ul>
            <p class="mt-3"><strong>💡 Datos Reales:</strong> Información extraída directamente de la base de datos con 
               cálculos automáticos y código de colores para análisis rápido</p>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>